module.exports = __webpack_public_path__ + "img/the-pallet-header-logo.16ebb4dc.png";